<div class="bary-table-list py-4 table-responsive">
  <table mdbTable [hover]="true" [small]="true">
    <thead>
      <tr [(ascending)]="pagination.reverse" [(predicate)]="pagination.predicate" (sortChange)="transition()" jhiSort>
        <th scope="col" jhiSortBy="login">
          <span jhiTranslate="userManagement.login">Login</span>
          <fa-icon icon="sort"></fa-icon>
        </th>
        <th scope="col" jhiSortBy="email">
          <span jhiTranslate="userManagement.email">Email</span>
          <fa-icon icon="sort"></fa-icon>
        </th>
        <th scope="col"><span jhiTranslate="bills.status">Activer</span></th>
        <th scope="col"><span>Nom</span></th>
        <th scope="col"><span jhiTranslate="userManagement.profiles">Profiles</span></th>
        <th scope="col" jhiSortBy="createdDate">
          <span jhiTranslate="userManagement.createdDate">Created Date</span>
          <fa-icon icon="sort"></fa-icon>
        </th>
        <th scope="col" jhiSortBy="lastModifiedDate">
          <span jhiTranslate="userManagement.lastModifiedDate">Last Modified Date</span>
          <fa-icon icon="sort"></fa-icon>
        </th>
        <th scope="col"></th>
      </tr>
    </thead>
    <tbody *ngIf="users">
      <tr mdbTableRow *ngFor="let user of users; trackBy: trackId">
        <td>{{ user.login }}</td>
        <td>{{ user.email }}</td>
        <td>
          <jhi-bary-input-switch [withColor]="true" [value]="user.activated" (onChangeEvent)="setActive(user, $event)"></jhi-bary-input-switch>
        </td>
        <td>{{ user.companyName }}</td>
        <td>
          <div *ngFor="let authority of user.authorities">
            <span class="badge badge-info">{{ authority }}</span>
          </div>
        </td>
        <td>{{ user.createdDate | date: 'dd/MM/yy HH:mm' }}</td>
        <td>{{ user.lastModifiedDate | date: 'dd/MM/yy HH:mm' }}<br />({{ user.lastModifiedBy }})</td>
        <td class="text-right">
          <jhi-bary-cta [actions]="ctaActions" (selectAction)="onSelectAction($event, user)"></jhi-bary-cta>
        </td>
      </tr>
      <tr [hidden]="users && users.length > 0">
        <td colspan="12" class="table-data-not-found">
          <div class="text-center">
            <p class="lead p-5" jhiTranslate="baryApp.customers.noData">No Customer</p>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</div>
